import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AutenticacaoModule, AuthContext } from "../../../Contexto/auth";
import useLocalStorageSec from "../../../hook/useLocalStorageSec";
import { ILogin, LoginSchema } from "../../../interfaces/ILogin";
import { UsuarioEnviarConfirmacaoEmail } from "../../../services/Identity.Service";
import { showToast } from "src/componentes";

export const LoginCode = () => {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setItem, getItem } = useLocalStorageSec();
  const { isLogged } = AutenticacaoModule();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ILogin>({
    resolver: yupResolver(LoginSchema),
  });

  useEffect(() => {
    const Load = () => {
      if (isLogged) {
        navigate("/inicio");
      }
    };
    Load();
  }, [isLogged, navigate]);

  useEffect(() => {
    if (getItem("login")) {
      setValue("email", getItem("login").email);
      setValue("senha", getItem("login").senha);
      setValue("lembrar", getItem("login").lembrar);
    }
  }, []);

  const onClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const onSubmit = async (loginData: ILogin, event: any) => {
    event.preventDefault();
    setLoading(true);

    await authContext
      .logIn(loginData)
      .then((response) => {
        if (response.success) {
          if (loginData.lembrar) {
            setItem("login", loginData);
          }
          const redirectUrl = localStorage.getItem("redirectAfterLogin");
          localStorage.removeItem("redirectAfterLogin");
          if (redirectUrl && redirectUrl !== "" && redirectUrl !== "/login" && redirectUrl !== "/") {
            window.location.href = redirectUrl;
          } else {
            navigate("/inicio");
          }
        } else {
          LoginError(response, loginData);
        }
      })
      .catch((error) => {
        console.error("Erro durante o login:", error);
        showToast({
          message: "Ocorreu um erro durante o login.",
          title: "Erro",
          variant: "Warning",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const LoginError = (response: any, loginData: ILogin) => {
    if (response.notifications[0].message === "EMAIL_PENDENTE_CONFIRMACAO") {
      UsuarioEnviarConfirmacaoEmail(loginData)
        .then((emailRes) => {
          if (emailRes.success) {
            showToast({
              message: "E-mail de confirmação enviado, verifique seu e-mail!",
              variant: "Info",
            });
          } else {
            showToast({
              message: emailRes.notifications[0].message,
              title: "Aviso",
              variant: "Warning",
            });
          }
          navigate("/confirmar-email", { state: { email: loginData.email } });
        })
        .catch((error) => {
          console.error("Erro ao enviar e-mail de ativação:", error);
          showToast({
            message:
              "Não foi possível enviar o e-mail de ativação automaticamente. Prossiga para a confirmação ou tente reenviar.",
            title: "Aviso",
            variant: "Warning",
          });
          navigate("/confirmar-email", { state: { email: loginData.email } });
        });
    } else {
      showToast({
        message: response.notifications[0].message,
        title: "Erro",
        variant: "Warning",
      });
    }
  };

  return {
    onSubmit,
    loading,
    onClickNavigate,
    handleSubmit,
    register,
    errors,
  };
};
